import { Icon } from '@reverse-hr/design-system';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useStoreState } from 'easy-peasy';
import { GTM } from '@app/gtm';
import { jobCompanyNameSelector } from '@model/Job/Job.selectors';
import {
  BRAND_APP_BASE_PATH,
  BRAND_BASE_URL,
  REVERSE_GROUP_BRAND_SQUARE_LOGOS,
} from '@app/constants/brand';
import { ICON_NAMES } from '@reverse-hr/design-system';
import { CONTRACT_SERVICE_TYPES } from '@model/Contract/Contract.constants';

export const JobCard = ({ job }) => {
  const { t } = useTranslation();
  const companyName = useStoreState(jobCompanyNameSelector);

  const wrapperClassNames = classNames('c-job-card', {
    'c-job-card--closed': job.closedOn,
  });

  const baseUrl = BRAND_BASE_URL[job.reverseGroupCompany];
  const appBasePath = BRAND_APP_BASE_PATH[job.reverseGroupCompany];

  const isJobReverseMarketing =
    job.serviceType === CONTRACT_SERVICE_TYPES.REVERSE_MARKETING;

  const linkHref = `${baseUrl}${appBasePath}/jobs/${job.id}`;

  const jobStatusIcon = isJobReverseMarketing
    ? ICON_NAMES.USER_STAR
    : JOB_STATES_ICONS[job.status];

  const cardStateLabel = isJobReverseMarketing
    ? 'homepage.jobList.marketing.cardState'
    : 'homepage.jobList.cardState';

  const trackNavigatingToJob = () => {
    GTM.trackGTMEvent({
      action: EVENT_ACTION_NAVIGATION_TO_JOB,
      label: `${companyName} - ${job.id} - ${job.title}`,
    });

    GTM.trackGA4Event(
      EVENT_ACTION_NAVIGATION_TO_JOB,
      companyName,
      `${job.id} - ${job.title}`,
    );
  };

  return (
    <div className={wrapperClassNames}>
      <a
        className="c-job-card__link"
        href={linkHref}
        target="_blank"
        onClick={trackNavigatingToJob}
      >
        <div className="c-job-card__header">
          <p className="c-job-card__title">{job.title}</p>

          {!!job.city && (
            <p className="c-job-card__location">
              <Icon name="icn-location-outline" size={16} />
              {job.city}
            </p>
          )}
        </div>

        <div className="c-job-card__footer">
          <div className="c-job-card__footer-left">
            {!!jobStatusIcon && !job.closedOn && (
              <Icon
                className="c-job-card__state-icon"
                name={jobStatusIcon}
                size={16}
              />
            )}

            {t(cardStateLabel, {
              context: job.closedOn ? 'closed' : job.status,
              date: job.closedOn ? new Date(job.closedOn) : null,
            })}
          </div>

          <div className="c-job-card__footer-right">
            <img
              src={`${__ENVIRONMENT_CONFIG__.PUBLIC_URL}${
                REVERSE_GROUP_BRAND_SQUARE_LOGOS[job.reverseGroupCompany]
              }`}
              alt={job.reverseGroupCompany}
              width={20}
              height={20}
            />
          </div>
        </div>
      </a>
    </div>
  );
};

const JOB_STATES = {
  SEARCHING: 'searching',
  INTERVIEWING: 'interviewing',
  CLOSING: 'closing',
};

const JOB_STATES_ICONS = {
  [JOB_STATES.SEARCHING]: 'icn-search-small',
  [JOB_STATES.INTERVIEWING]: 'icn-chat',
  [JOB_STATES.CLOSING]: 'icn-flag-outline',
};

const EVENT_ACTION_NAVIGATION_TO_JOB = `Navigazione verso il dettaglio di una job`;
